import React, { useState, useEffect } from 'react';
import '../styles/filters.css';

const Filters = ({ brandsModels, filters, onFilterChange, onApply }) => {
  const [expanded, setExpanded] = useState(() => new Set(filters.brand ? [filters.brand] : []));
  const [priceMin, setPriceMin] = useState(filters.minSupplierPrice || '');
  const [priceMax, setPriceMax] = useState(filters.maxSupplierPrice || '');

  useEffect(() => {
    setPriceMin(filters.minSupplierPrice || '');
    setPriceMax(filters.maxSupplierPrice || '');
  }, [filters.minSupplierPrice, filters.maxSupplierPrice]);

  const applyPrice = (min, max) => {
    onFilterChange({ ...filters, minSupplierPrice: min, maxSupplierPrice: max });
  };

  const handlePriceKey = (e) => {
    if (e.key === 'Enter') applyPrice(priceMin, priceMax);
  };

  const hasPriceFilter = filters.minSupplierPrice || filters.maxSupplierPrice;

  const toggleExpand = (brand) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      next.has(brand) ? next.delete(brand) : next.add(brand);
      return next;
    });
  };

  const handleSelectBrand = (brand) => {
    if (filters.brand === brand) {
      onFilterChange({ ...filters, brand: '', model: '' });
    } else {
      onFilterChange({ ...filters, brand, model: '' });
      setExpanded((prev) => new Set(prev).add(brand));
    }
  };

  const handleSelectModel = (brand, model) => {
    if (filters.brand === brand && filters.model === model) {
      onFilterChange({ ...filters, model: '' });
    } else {
      onFilterChange({ ...filters, brand, model });
    }
  };

  const handleBrandReset = () => {
    onFilterChange({ ...filters, brand: '', model: '' });
  };

  const handlePriceReset = () => {
    setPriceMin('');
    setPriceMax('');
    onFilterChange({ ...filters, minSupplierPrice: '', maxSupplierPrice: '' });
  };

  const entries = Object.entries(brandsModels);

  const handleNewItemsToggle = () => {
    onFilterChange({ ...filters, newItems: !filters.newItems, brand: '', model: '' });
  };

  // Єдині реальні значення сезону в каталозі (перевірено на даних) — не
  // довідник з бекенда, бо значень лише 3 і вони не змінюються.
  const SEASON_OPTIONS = ['Зима', 'Лето', 'Весна-Осень-Лето'];
  const handleSelectSeason = (season) => {
    onFilterChange({ ...filters, season: filters.season === season ? '' : season });
  };

  return (
    <div className="filters-section">
      <div className="filters-header">
        <h3>Фильтры</h3>
        <div className="filters-header-actions">
          {(filters.brand || filters.model) && !filters.newItems && (
            <button className="btn-clear" onClick={handleBrandReset}>Сбросить</button>
          )}
          {onApply && (
            <button className="btn-apply" onClick={onApply}>Применить</button>
          )}
        </div>
      </div>

      <button
        className={`novelties-btn${filters.newItems ? ' active' : ''}`}
        onClick={handleNewItemsToggle}
      >
        {filters.newItems ? 'Вернуться к каталогу' : 'Новинки'}
      </button>

      <div className="price-filter">
        <div className="price-filter-header">
          <span className="price-filter-label">Цена поставщика</span>
          {hasPriceFilter && (
            <button className="btn-clear" onClick={handlePriceReset}>Сбросить</button>
          )}
        </div>
        <div className="price-filter-inputs">
          <input
            className="price-input"
            type="number"
            placeholder="От"
            value={priceMin}
            onChange={e => setPriceMin(e.target.value.replace(',', '.'))}
            onBlur={() => applyPrice(priceMin, priceMax)}
            onKeyDown={handlePriceKey}
            min="0"
          />
          <span className="price-separator">—</span>
          <input
            className="price-input"
            type="number"
            placeholder="До"
            value={priceMax}
            onChange={e => setPriceMax(e.target.value.replace(',', '.'))}
            onBlur={() => applyPrice(priceMin, priceMax)}
            onKeyDown={handlePriceKey}
            min="0"
          />
        </div>
      </div>

      <div className="price-filter">
        <div className="price-filter-header">
          <span className="price-filter-label">Сезон</span>
          {filters.season && (
            <button className="btn-clear" onClick={() => onFilterChange({ ...filters, season: '' })}>Сбросить</button>
          )}
        </div>
        <div className="season-filter-options">
          {SEASON_OPTIONS.map(s => (
            <button
              key={s}
              className={`season-btn${filters.season === s ? ' active' : ''}`}
              onClick={() => handleSelectSeason(s)}
            >
              {s}
            </button>
          ))}
        </div>
      </div>

      <div className="filters-tree">
        {entries.length === 0 && (
          <div className="tree-empty">Совпадений не найдено</div>
        )}

        {entries.map(([brand, models]) => {
          const isExpanded = expanded.has(brand);
          const isBrandActive = filters.brand === brand;

          return (
            <div className="tree-node" key={brand}>
              <div className={`tree-item tree-brand ${isBrandActive ? 'active' : ''}`}>
                <span
                  className={`tree-toggle ${isExpanded ? 'expanded' : ''}`}
                  onClick={() => toggleExpand(brand)}
                >
                  ▶
                </span>
                <span className="tree-label" onClick={() => handleSelectBrand(brand)}>
                  {brand}
                </span>
              </div>

              {isExpanded && (
                <div className="tree-children">
                  {models.map((model) => {
                    const isModelActive = isBrandActive && filters.model === model;
                    return (
                      <div
                        key={model}
                        className={`tree-item tree-model ${isModelActive ? 'active' : ''}`}
                        onClick={() => handleSelectModel(brand, model)}
                      >
                        {model}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Filters;
